/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import { Divider } from "antd";
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import ProductDetail from "../ProductDetail";
import SimilarProducts from "../SimilarProducts";
import { getSimilarProducts } from "reducers/similarProducts";
/* Project Import will be here */

/* Styles will be here */
import "../../../pages/ProductDetail/style/productDetailStyle.css";
/* Styles will be here */

class ProductDetailsContainer extends Component {
    onVariantChangeInProductDetails = (productId) => {
        if (this.props.appSettings.isShowSimilarProducts && productId !== 0) {
            /* Update the similar product when product variant change */
            this.props.actions.getSimilarProducts(productId);
        }
    }

    render() {
        const { appSettings } = this.props;
        const propsSelectedProductId = parseInt(this.props.productId, 10);
        const reducerSelectedProductId = this.props.common.productDetailsSelectedProductId;

        return (
            <React.Fragment>
                <ProductDetail
                    {...this.props}
                    closeProductDetailsDrawer={this.props.closeProductDetailsDrawer}
                    onVariantChangeInProductDetails={this.onVariantChangeInProductDetails}
                />

                {/* Check for SimilarProducts config */}
                {appSettings.isShowSimilarProducts && (reducerSelectedProductId !== 0 && propsSelectedProductId !== 0 && reducerSelectedProductId === propsSelectedProductId) &&
                    <React.Fragment>
                        <div className="p-3 w-100"><Divider /></div>

                        <SimilarProducts
                            {...this.props}
                            selectedProductId={reducerSelectedProductId}
                        />
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        appSettings: state.appSettings,
        common: state.common
    };
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(
            {
                getSimilarProducts
            },
            dispatch
        )
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetailsContainer);